import { render, staticRenderFns } from "./setMaterial.vue?vue&type=template&id=71133c39&"
import script from "./setMaterial.vue?vue&type=script&lang=js&"
export * from "./setMaterial.vue?vue&type=script&lang=js&"
import style0 from "./setMaterial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports